import { createClient } from '@supabase/supabase-js';

const ORG_ID = process.env.REACT_APP_ORG_ID || 'default';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    global: {
      headers: {
        'x-org-id': ORG_ID,
      },
    },
  }
);

export const orgId = ORG_ID;
export default supabase;
